<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container">
                <div class="dashboard-content-inner" >

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline row" v-bind:class="{'hidden-xs hidden-sm': $root.user.tipo == 'contratante'}">
                        <div class="col-xs-12 col-xl-10 col-sm-fill hidden-xs">
                            <h3>
                                <i class="las" :class="$router.currentRoute.meta.icon"></i>
                                {{$router.currentRoute.meta.title}}
                            </h3>
                        </div>
                        <div v-if="$root.user.tipo != 'contratante'" class="col-xs-12 col-sm-fit">
                            <router-link class="button button-lg color-primary margin-top-10" :to="{'name': 'CadastrarAgendamentos', 'query': {'t': (new Date().getTime())}}" style="width: 100%;">
                                Agendar <i class="las la-plus-circle"></i>
                            </router-link>
                        </div>
                    </div>

                    <div class="row margin-top-20">

                        <div v-if="$root.user.tipo != 'contratante'" class="col-xl-12 margin-bottom-20">
                            <p class="help">
                                <i class="las la-question-circle"></i>
                                Agende visitas avulsas, ou utilize os filtros abaixo para acompanhar o relatório de visitas.
                            </p>
                        </div>      
                        <div v-if="$root.user.tipo == 'contratante'" class="col-xl-12 margin-bottom-20">
                            <p class="help">
                                <i class="las la-question-circle"></i>
                                Acompanhe abaixo o relatório de visitas.
                            </p>
                        </div>                                                     
                        <div v-if="$root.user.tipo != 'contratante'" class="col-xl-12">
                            <form method="get" style="width: 100%;" class="margin-bottom-0" v-on:submit.prevent="form.page = 1;get(true);" novalidate="">
                                <div class=" row">
                                    <div class="col-xs-12 col-md-12 col-lg-6 col-xl-4">
                                        <div class="submit-field margin-bottom-10">
                                            <h5>Pesquisa:</h5>
                                            <input type="text" placeholder="Pesquise aqui.." required="" class="with-border margin-bottom-0" v-model="form.pesquisa">
                                        </div>
                                    </div>
                                    <div class="col-xs-6 col-md-6 col-lg-3 col-xl-2">
                                        <div class="submit-field margin-bottom-10">
                                            <h5>De:</h5>
                                            <input type="date" required="" class="with-border margin-bottom-0" v-model="form.dataInicio">
                                        </div>
                                    </div>        
                                    <div class="col-xs-6 col-md-6 col-lg-3 col-xl-2">
                                        <div class="submit-field margin-bottom-10">
                                            <h5>Até:</h5>
                                            <input type="date" required="" class="with-border margin-bottom-0" v-model="form.dataFinal">
                                        </div>
                                    </div>    
                                    <div v-if="$root.user.tipo == 'admin'" class="col-xl-12"></div>
                                    <div v-if="$root.user.tipo == 'admin'" class="col-xs-12 col-md-6 col-lg-3">
                                        <div class="submit-field margin-bottom-10">
                                            <h5>Equipe:</h5>
                                            <select class="with-border" v-model="form.equipeCod">
                                                <option value="" selected="">
                                                    Todas
                                                </option>
                                                <option v-for="(item, index) in equipes.itens" :key="item.cod" :value="item.cod">{{item.nome}}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-xs-6 col-md-6 col-lg-3 col-xl-2">
                                        <div class="submit-field margin-bottom-10">
                                            <h5>Status:</h5>
                                            <select class="with-border margin-bottom-0" v-model="form.status" name="status">                                  
                                                <option value="null" selected>Todos</option>
                                                <option value="0">Pendente</option>
                                                <option value="1">Em andamento</option>
                                                <option value="2">Concluída</option>
                                                <option value="-1">Cancelada</option>
                                            </select> 
                                        </div>
                                    </div>    
                                    <div class="col-xs-6 col-md-6 col-lg-3 col-xl-3">
                                        <div class="submit-field margin-bottom-10">
                                            <h5>Filtrar/ordenar por:</h5>
                                            <select class="with-border margin-bottom-0" v-model="form.filtro" name="filtro">                                  
                                                <option value="ultimos">Últimos criados</option>
                                                <option value="atualizados">Atualizadas recentemente</option>
                                                <option value="checkin">Check-in realizado</option>
                                                <option value="checkout">Check-out realizado</option>
                                                <option value="proximos">Data próxima</option>
                                                <option value="hoje">Agendadas para hoje</option>
                                                <option value="amanha">Agendadas para amanhã</option>
                                            </select> 
                                        </div>
                                    </div>                                                                                                                     
                                    <div class="col-xs-fit align-self-md-end">
                                        <div class="submit-field margin-bottom-10">
                                            <h5 style="opacity: 0;" class="hidden-lg hidden-xl hidden-md">:</h5>
                                            <button class="button color-gray" style="height: 50px; width: 100%;">
                                                <i class="las la-search"></i>
                                            </button>  
                                        </div>
                                    </div>                                    
                                </div>
                                <div class="hidden-sm hidden-xl margin-top-20"></div>
                            </form>                      

                        </div>                         
                        
                        <div class="col-xl-12 col-xs-12 margin-top-10" v-if="$root.user.tipo != 'contratante'">
                            <div class="row">
                                <div class="col-xl-2 col-xs-6">
                                    <button class="button small gray full-width" type="button" v-bind:class="{'color-white': form.tab == 'lista'}" v-on:click="setTab('lista')">
                                        <i class="las la-list"></i>
                                        Lista
                                    </button>
                                </div>
                                <div class="col-xl-2 col-xs-6">
                                    <button class="button small gray full-width" type="button" v-bind:class="{'color-white': form.tab == 'calendario'}" v-on:click="setTab('calendario')">
                                        <i class="las la-calendar"></i>
                                        Calendário
                                    </button>
                                </div>
                            </div>                            
                        </div>

                        <div class="col-xl-12 col-xs-12" v-if="form.tab == 'calendario' ">
                            <FullCalendar :options="calendarOptions" class="margin-top-15" />
                        </div>

                        <div class="col-xl-12 col-xs-12" v-if="form.tab == 'lista' ">
                            <div v-show="data.itens.length == 0 && data.loaded">
                                <center>
                                    <img src="static/images/empty.svg" style="width: 300px;">
                                    <h3 class="center" style="line-height: 120%; font-weight: 200">
                                        Nenhum resultado encontrado.
                                    </h3>
                                </center>     
                            </div>

                            <div class="parent table-scroll margin-top-30" style="overflow-x: auto !important; border: 1px solid #ddd;" v-if="data.loaded && data.itens.length > 0">
                                <table class="child table table-bordered  table-responsive table-bordered-default">
                                    <thead>
                                        <th style="min-width: 70px; width: 70px;">
                                            OS
                                        </th>
                                        <th style="min-width: 140px; width: 140px; text-align: center;">
                                            Agendado para
                                        </th>
                                        <th v-if="$root.user.tipo != 'contratante'" style="min-width: 200px;">
                                            Cliente
                                        </th>
                                        <th v-if="$root.user.tipo != 'contratante'" style="min-width: 170px; width: 170px">
                                            Categoria
                                        </th>                                        
                                        <th v-if="$root.user.tipo != 'prestador'" style="min-width: 150px;">
                                            Equipe
                                        </th>    
                                        <th style="min-width: 85px; width: 85px; text-align: center;">
                                            Check-in
                                        </th>
                                        <th style="min-width: 90px; width: 90px; text-align: center;">
                                            Check-out
                                        </th>
                                        <th style="min-width: 90px; width: 90px; text-align: center;">
                                            Duração
                                        </th>                                        
                                        <th style="min-width: 130px; width: 130px; text-align: center;">
                                            Status
                                        </th>  
                                        <th v-if="$root.user.tipo != 'contratante'" style="min-width: 130px; width: 130px; text-align: center;">
                                            Ações
                                        </th>
                                    </thead>
                                    <tbody>   
                                        <tr v-for="(item, index) in data.itens" :key="item.cod" v-on:click="$root.user.tipo != 'contratante' ? $root.go('EditarAgendamentos', JSON.stringify({'c': item.cod})) : null" class="click">
                                            <td data-label="OS:">
                                                <b>
                                                    #{{item.id}}
                                                </b>
                                            </td> 
                                            <td data-label="Agendado para:" style="text-align: center;">
                                                <i class="las la-calendar"></i> {{item.data | formatDate}}
                                            </td>          
                                            <td v-if="$root.user.tipo != 'contratante'" data-label="Cliente:">
                                                <router-link style="text-decoration: underline;" :to="{'name': 'EditarClientes', 'query': {'c': item.clienteCod}}">
                                                    {{item.cliente.empresa ? item.cliente.empresa : item.cliente.nome}}
                                                </router-link>
                                            </td>    
                                            <td v-if="$root.user.tipo != 'contratante'" data-label="Categoria:">
                                                <span class="dashboard-status-button color-blue" style="text-transform: uppercase;">{{item.cliente.categoria ? item.cliente.categoria : 'Sem categoria'}}</span>
                                            </td>                                                                                        
                                            <td v-if="$root.user.tipo != 'prestador'" data-label="Equipe:">
                                                <a >
                                                    {{item.equipe.nome}}
                                                </a>
                                            </td>                                   
                                            <td data-label="Check-in:" style="text-align: center;">
                                                <span v-if="item.checkin != '0000-00-00 00:00:00'">{{item.checkin | formatDate}}</span>
                                                <span v-if="item.checkin == '0000-00-00 00:00:00'">-</span>
                                            </td>   
                                            <td data-label="Check-out:" style="text-align: center;">
                                                <span v-if="item.checkout != '0000-00-00 00:00:00'">{{item.checkout | formatDate}}</span>
                                                <span v-if="item.checkout == '0000-00-00 00:00:00'">-</span>
                                            </td> 
                                            <td data-label="Duração:" style="text-align: center;">
                                                {{item.duracao ? item.duracao + 'h' : '-'}}
                                            </td>                                                                                           
                                            <td data-label="Status:" style="text-align: center;">
                                                <span v-if="item.status == 0" class="dashboard-status-button color-orange" style="display: inline-block; text-align: center; margin-top: 3px;">
                                                    Pendente
                                                </span>
                                                <span v-if="item.status == 1" class="dashboard-status-button color-blue" style="display: inline-block; text-align: center; margin-top: 3px;">
                                                    Em andamento
                                                </span>
                                                <span v-if="item.status == 2" class="dashboard-status-button color-green" style="display: inline-block; text-align: center; margin-top: 3px;">
                                                    Concluída
                                                </span>
                                                <span v-if="item.status == -1" class="dashboard-status-button color-red" style="display: inline-block; text-align: center; margin-top: 3px;">
                                                    Cancelada
                                                </span>                                                
                                            </td> 
                                            <td v-if="$root.user.tipo != 'contratante'" data-label="" class="acoes" style="text-align: center;">
                                                <i title="Visita reagendada" v-bind:class="{'disabled': item.reagendado == 0}" class="las la-clock"></i>
                                                <i title="Visita com fotos" v-on:click.stop.prevent="$root.go('EditarAgendamentos', JSON.stringify({'c': item.cod, 'fotos': true}))" v-bind:class="{'disabled': !item.arquivos}" class="las la-camera"></i>
                                                <i title="Visualizar Ordem de Serviço" v-on:click.stop.prevent="$root.go('OS', JSON.stringify({'c': item.cod}))" v-bind:class="{'disabled': item.status != 2}" class="las la-file-alt"></i>
                                                <i v-on:click.stop.prevent="openMenu(item)" title="Opções" class="las la-ellipsis-v" style="color: #000 !important; font-size: 24px !important; top: 2px;"></i>

                                                <div class="dropdown" v-show="item.menu">
                                                    <ul>
                                                        <li v-on:click.stop.prevent="$root.go('OS', JSON.stringify({'c': item.cod}))">Imprimir OS</li>
                                                        <li v-on:click.stop.prevent="$root.go('EditarAgendamentos', JSON.stringify({'c': item.cod}))">Visualizar / Editar</li>
                                                        <li v-on:click.stop.prevent="cancelar(item.cod);" v-if="item.status == 0">Cancelar</li>
                                                    </ul>
                                                </div>

                                            </td>                               
                                        </tr> 
                                    </tbody>
                                </table>
                            </div>

                            <div class="pagination-container margin-top-60 margin-bottom-60">
                                <nav class="pagination">
                                    <ul>
                                        <li class="pagination-arrow" v-show="data.page > 1" v-on:click="form.page = (data.page - 1); get(true);">
                                            <a>
                                                <i class="material-icons">arrow_back</i>
                                                Anterior
                                            </a>
                                        </li>
                                        <li class="pagination-arrow" v-show="data.page >= 1 && data.page < (data.pages.length)" v-on:click="form.page = (data.page + 1); get(true);">
                                            <a>
                                                Próxima
                                                <i class="material-icons">arrow_forward</i>
                                            </a>
                                        </li>    
                                        <br class="hidden-lg hidden-xl hidden-md">                                        
                                        <li v-for="(item, index) in data.pages" v-show="item.show">
                                            <a class="" v-bind:class="{'current-page': item.index == data.page}" v-on:click="form.page = item.index; get(true);">
                                                {{item.index}}
                                            </a>
                                        </li>
                                    </ul>
                                </nav>
                            </div>

                        </div>
                    </div>            

                </div>
            </div>
        </div>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'

export default {
    name:                           'Visitas',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar,
        'FullCalendar':             FullCalendar
    },     
    filters: {
        toMoney: function(value) {
            if (value) {
                return parseFloat(value).toFixed(2).toLocaleString('pt-br', {minimumFractionDigits: 2});
            } else {
                return "0.00";
            }
        },        
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            if (time) {
                d = time.split(":");
                time = d[0] + ":" + d[1];
            }
            return date + (time ? (" " + time) : "");
        }
    },        
    data () {
        var self                    = this;
        return {
            calendarOptions: {
                eventClick: function(info) {
                    console.log("eventClick()", info);
                    window.open("#/visitas/editar?c=" + info.event.extendedProps.cod, "_blank");

                },  
                eventRender: function( event, element, view ) {
                       element.find('.fc-title').prepend('<span class="glyphicon"></span> '); 
                },           
                height: "auto",                
                locale: 'pt-br',
                timeFormat: 'HH:mm',
                editable: false,
                eventLimit: false,
                themeSystem:'standard',
                displayEventTime: this.displayEventTime,
                slotLabelFormat: 'HH:mm',
                // allDayText: '24 horas',
                columnFormat: 'dddd',
                header: {
                    left: "BackwardButton, ForwardButton",
                    center: "title"
                },
                customButtons: {
                    ForwardButton: {
                        icon: "right-single-arrow",
                        click: function() {}
                    },
                    BackwardButton: {
                        icon: "left-single-arrow",
                        click: function() {}
                    }
                },
                buttonIcons: {
                    close: ' la la-times',
                    prev: ' la la-chevron-left',
                    next: ' la la-chevron-right',
                    prevYear: ' la la-chevron-left',
                    nextYear: ' la la-chevron-right'
                },                
                buttonText: {
                    today: 'Hoje',
                    month: 'Mês',
                    week: 'Semana',
                    day: 'Hoje',
                    list: 'Lista'
                },                
                plugins: [ dayGridPlugin, interactionPlugin ],
                initialView: 'dayGridMonth',
                events: [
                ]                
            },            
            "data":                 {
                "itens":            []
            },
            "equipes":              {
                "itens":            []
            },            
            "loading": {
                "submit":           false
            },
            "form": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,
                "page":             1,
                "filtro":           "ultimos",
                "tab":              "lista",
                "equipeCod":        "",
                "status":           null
            }              
        }
    },
    methods: {  
        hideMenu: function() {
            var self        = this;
            console.log("hideMenu()");
            self.data.itens.forEach(function(item) {
                if (item.menu) item.menu = false;
            });
            self.$forceUpdate();
        },
        openMenu: function(item) {
            var self        = this;
            console.log("openMenu()", item);
            self.hideMenu();
            item.menu = (item.menu ? false : true);
            self.$forceUpdate();
        },
        setTab: function(tab) {
            var self        = this;
            console.log("setTab()", tab);
            self.form.tab = tab;
            this.$router.push({query: {"tipo": tab}})
        },
        getEquipes: function() {
            var self        = this;
            console.log("getEquipes()");
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "page":         1
                    }
                };

                axios.get("api/equipes.php", form)
                .then(response => {
                    
                    console.log("getEquipes() response", response);
                    self.equipes       = response.data.result;
                    loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getEquipes() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        },                
        get: function(e) {
            var self        = this;
            console.log("get()", self.form);
            loading.show();
            return new Promise(function(resolve, reject) {

                axios.get("api/visitas.php", {params: self.form})
                .then(response => {
                    
                    console.log("get() response", response);  
                    self.data   = response.data.result; 

                    if (self.form.tab == "calendario") {
                        self.calendarOptions.events     = [];
                        self.data.itens.forEach(function(item) {

                            var classes = ["click"];
                            if (item.status == 0) {
                                classes.push("color-orange");
                            } else if (item.status == 1) {
                                classes.push("color-blue");
                            } else if (item.status == 2) {
                                classes.push("color-green");
                            } else if (item.status == -1) {
                                classes.push("color-red");
                            }

                            self.calendarOptions.events.push({
                                title:  ("[" + item.equipe.nome + "]") + " - " + (item.cliente.empresa ? item.cliente.empresa : item.cliente.nome), 
                                date:   item.data,
                                borderColor: "#FFFFFF",
                                classNames: classes,
                                extendedProps: item
                            });
                        });
                        console.log("setou events", self.calendarOptions)
                    }

                    loading.hide();
                    self.$forceUpdate();
                    resolve(response.data.result);
                    self.$root.scrollTop();                    
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    if (e) loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        },
        cancelar: function(cod) {
            console.log("cancelar()", cod);
            
            var self                = this;

            var request             = function() {
                var form = {
                    "_cod":         self.$root.user.cod, 
                    "_token":       self.$root.user.token,
                    "cod":          cod,
                    "acao":         "cancelar"
                };                

                loading.show();
                
                console.log("cancelar() request", form);

                axios.put("api/visitas.php", form)
                .then(response => {
                    console.log("cancelar() response", response)
                    loading.hide();
                    if (response.data.message) alert(response.data.message);
                    self.get(true);

                })
                .catch(error => {
                    console.log("cancelar() error", error)
                    loading.hide();
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });                
            }

            confirm("Você tem certeza que deseja cancelar a visita?", function() {
                request();
            });
        },             
        del: function(cod) {
            console.log("del()", cod);
            var self                = this;
            confirm("Você tem certeza que deseja apagar?", function() {
                var form                = JSON.parse(JSON.stringify(self.form));
                form.cod                = cod;
                loading.show();
                
                axios.delete("api/visitas.php", {params: form})
                .then(response => {
                    console.log("del() response", response)
                    self.get();
                })
                .catch(error => {
                    console.log("del() error", error)
                    loading.hide();
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });
        }                           
    },
    created: function() {
        var self = this;
    },
    deactivated: function() {
        var self = this;
        $('body').off('click');

    },
    activated: function() {
        var self = this;
        console.log("activated>", self)

        $('body').off('click');
        $('body').on('click', function(e) {
            console.log("click")
            
            if($(e.target).closest('.dropdown').length == 0) {
               self.hideMenu();
            } else {
            }
        });   

        if (self.$route.query.tipo == "calendario") {
            self.form.tab = self.$route.query.tipo;
        }

        loading.show();
        Promise.resolve()
        .then(self.get)
        .then(self.getEquipes)
        .then(function() {              
            loading.hide();
        }).catch(function(error) {
            console.log("erro ao buscar", error);
            loading.hide();
        });
    }    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .bloqueado {
        opacity: 0.5 !important;
    }
    .acoes i {
        cursor: pointer;
        font-size: 18px !important;
        color: #3a8fc8 !important;
    }
    .acoes i.disabled {
        opacity: 0.5 !important;
        pointer-events: none !important;
    }

    .table td .dropdown {
        position: absolute;
        right: 10px;
        z-index: 99999;
    }
    .table td .dropdown ul {
        position: absolute;
        background: #fff;
        border-radius: 6px;
        top: 100%;
        right: 10px;
        padding: 10px;
        z-index: 99999;
        border: 1px solid #ddd;
    }

    .table td .dropdown li {
        list-style: none;
        text-align: left;
        width: 150px;
        padding: 5px 10px;
    }

 </style>



// WEBPACK FOOTER //
// src/components/Visitas.vue